import getApiClient from '../../../../../plugins/api'

export default {
    loadChart: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        api.get('/agency/trips/top_selling_chart')
            .then(result => {
                self.data = result.data
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    }
}
